import ProjectClient from '../api/project';

const FETCHING_SHARED_PROJECT = "FETCHING_SHARED_PROJECT",
  FETCHING_SHARED_PROJECT_SUCCESS = "FETCHING_SHARED_PROJECT_SUCCESS";

export default {
  namespaced: true,
  state: {
    isLoading: false,
    error: null,
    data: {
      estimate_json: null,
    },
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
    hasError(state) {
      return state.error !== null;
    },
    error(state) {
      return state.error;
    },
    getEstimateJson(state) {
      return state.data.estimate_json;
    }
  },
  mutations: {
    [FETCHING_SHARED_PROJECT](state) {
      state.isLoading = true;
      state.error = null;
      state.data = null;
    },
    [FETCHING_SHARED_PROJECT_SUCCESS](state, data) {
      state.isLoading = false;
      state.error = null;
      state.data = data;
    },
  },
  actions: {
    async fetchSharedProject({commit}, shareCode) {
      commit(FETCHING_SHARED_PROJECT);
      try {
        let response = await ProjectClient.fetchSharedProject(shareCode);
        if (response.isAxiosError) {
          throw response;
        }

        commit(FETCHING_SHARED_PROJECT_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        // commit(FETCHING_PACKS_ERROR, error); // TODO throw error
        return null;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/viewSharedProject.js